module Client.Admin.EditUser.Tags.Delete

open System
open Elmish
open Client
open Shared
open Illy.SafeStack.Client
open Fable.React
open Shared.Admin.Tags.StronglyTypedIds
open Shared.Admin.Tags.Delete

type Model = 
    {
        TagId: TagId 
        Saving: bool
    }

type Msg = 
    | ApiError of ApiError
    | SaveResult of FailureReason option
    | CloseOverlay  
    | SaveClicked 

type Event = 
    | CloseOverlay 
    | ApiError of ApiError 
    | DeleteSuccessful of TagId * notification: string 

let init tagId = 
    { 
        TagId = tagId 
        Saving = false
    }, []

let update msg model = 
    match msg with 
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event 
    | SaveClicked -> 
        {model with Saving = true},
        Api.secureCall<IDeleteTagApi,_,_,_> SecuredRoute.Admin (fun api -> api.delete) model.TagId SaveResult Msg.ApiError
        |> SideEffect.Cmd
    | SaveResult reason -> 
        match reason with 
        | None
        | Some NothingToDo -> model, (model.TagId, "Tag was deleted successfully.") |> Event.DeleteSuccessful |> SideEffect.Event

let view model dispatch = 
    jQueryUI.modal "Delete Tag" 50 Msg.CloseOverlay dispatch (Some 800) [
        yield jQueryUI.illy_info [
            str "Do you really want to delete this tag?"
        ]
        yield! UI.saveControls (Some "Delete") false model.Saving SaveClicked Msg.CloseOverlay dispatch
    ]